import { getLink } from '../../../utils/utils'; 

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      «Kiam mi ekvidis la ĉielan lumon, mi eĉ ne ekmiris tro. 
      Nu, ĉu gravas? – rezonis mi. 
      Ĉu tio min iamaniere tuŝas? 
      Estu saĝuloj kaj potenculoj, kiuj prizorgu la bonstaton de la urbo; kaj mi havas sufiĉajn zorgojn pro mia propra devo.
    </p>
    
    <p class="mb-3">
      Mia devo estas kontroli aŭskultilojn. Apud ĉiu domo staras ili kaj aŭskultas pensojn de ĉiuj loĝantoj. 
      Pri nekonvenaj pensoj ili raportas al Ofica Komisiono, kaj tie oni bone scias «forigi netaŭgulojn». 
    </p>
    
    
    <p class="mb-3">
      Kaj jen, tiuj porkoj nokte malfunkciigas aŭtomatojn, kaj neniu scias, kiel ili tion faras. 
      Oni diras, ke ili uzas pensajn kanalojn por difektigi la aŭskultilojn; sed ĉu la aŭtomatoj estas tiel stultaj por ne defendi sin? 
      Mi opinias, ili frenezigas la aŭtomatojn, ja mi trovas ilin matene kun kaĉo en la cerbo, ili forgesas ĉion aŭditan, ne plu obeas ordonojn, kaj ilia uzado jam ne estas ebla.
    </p>
    
    <p class="mb-3">
      Hodiaŭ aperis tiom multe da difektitaj aparatoj, ke mi eĉ liberan sekundon ne havis. 
      Preskaŭ ĉiuj en mia distrikto ne funkcias.
    </p>
    
    <p class="mb-3">
      Kiam mi la duan fojon ekvidis la lumon, ĝi jam estis sur horizonto; pli pala, sed pli vasta, ĝi brakumis tutan ĉirkaŭvidon. 
      La lumo estis blua, kun blanka aŭreolo, sufiĉe hela por vespero. 
    </p>
    
    <p class="mb-3">
      Mi ekpensis pri aliuj homoj. Eble, ili ion scias?
    </p>
    
    <p class="mb-3">
      Tamen, en la «Komuna penso» neniu informo aperis, kaj la homoj mem ne povas ion ekscii, ili ja loĝas en la Domoj. 
      Nur ni, kontrolistoj, rajtas paŝi surtere. Oni donas al ni specialan vestaĵon, okulvitrojn… 
      Tiel ni povas elteni la Terajn kondiĉojn, tute ne taŭgajn normale por la homa vivo. Vi imagu, iu naskis la ideon, ke la Tero, Tero mem estis iam loĝloko de homaro! 
      Kun siaj ventoj, pluvoj, venenaj estaĵoj kaj plantoj! Oni ne povas ja kelkajn paŝojn fari sur la Tero, sen ke onin ne vundu io danĝera. 
      Kaj mikroboj, virusoj? 
      Evidente, la tuta vivo de praa homo estis tiam batalo por la vivo; ĉiun tagon, ĉiun monaton li gajnis en senfina ludado kun morto. 
      Kun natura morto, ni diru. La homo vivis kiel besto, kaj kiel besto li mortis.
    </p>
    
    <p class="mb-3">
      Ĉu eblas eĉ komparo kun nia vivo, la vivo digna, la sola inda La Homon? 
      Fin-fine li akiris sian merititan pozicion en la mondo kaj forigis de si ĉiujn fi-biologiajn trajtojn, plej grave la venon de l’ morto. 
      Ĉe ni oni mortas nur laŭ la ordonoj de l’ Moŝto!
    </p>
    
    <p class="mb-3">
      Estas la bazo de civilizita vivo: laŭ reguloj vivi, laŭ reguloj morti.
    </p>
    
    <p class="mb-3">
      Eĉ neimageble: homo komencas ian laboron, kaj en mezo – mortas. 
      Nenio sekvas plu. Homoj vivis kiel senfortaj, sencelaj eroj de iu Brown’a movado; ĉiu tago puŝis ilin tien, reen… 
      Kun neordigitaj pensoj, neatendita morto – homo ne estis ja Homo! 
      Nur ni, kun nia Moŝto…»
    </p>
    
    <p class="mb-3">
      Subite la aero ektremis, la blua fulmo ĉirkaŭumis la Teron, kaj pro neeltenebla brilo li fermis la okulojn. Li ne malfermis ilin plu.
    </p>
    
    <p class="mb-3">
      Matene super la Tero leviĝis l’Suno. 
    </p>
    
    <p class="mb-3">
      Ĝi prilumis forlasitajn Domojn, kaj kelkon da homoj, vestitaj en defendkostumoj. 
      La homoj ĵus forlasis la Domojn, kaj timeme, senkomprene ĉirkaŭrigardadis; en iliaj rigardoj brilis miro kaj disiluzio. 
    </p>
    
    <p class="mb-3">
      Tiuj homoj dum jardekoj batalis kontraŭ la Moŝto; ili, la plej elstaraj cerboj de la Tero, unuiĝinte inventis la Ilon, tiun bluan energian kampon, kiu disfunkciigis la aŭtomatojn de la Moŝto, senigis ĝin de ilia apogo, de la bazo de ekzisto: nur homoj, sen aŭtomatoj, estas ja senfortaj!
    </p>
    
    <p class="mb-3">
      Kaj jen disvaporiĝis la Moŝto, neniu plu kontrolos ĉiutage niajn pensojn, ordonos al ni la farojn, pravigos la tutan nian vivon. Ni estas liberaj!
    </p>
    
    <p class="mb-3">
      La tuta vivo haltis. 
      La Domoj, inventaĵo de la Moŝto, ne plu funkciis, kaj homoj pereis pro manko de la vivnecesaĵoj, ili ne scipovis ja propramane liveri al si manĝaĵojn kaj trinkaĵojn. 
      Ĉion faris maŝinoj, kaj sen ili la homoj estis senpovaj kaj senfortaj. 
      Ili ne povis eĉ spiri per Tera aero, la artefarita aero en Domoj estis por ili pli konvena…
    </p>
    
    <p class="mb-3">
      La plimulto mortis en unuaj horoj, eĉ ne pro manko de manĝo kaj aero – pro timo. 
      Estis detruitaj ĉiuj iliaj kutimoj, la tuta ordo de la vivo esris rompita. 
      Neniu povas travivi la pereon de sia mondo. 
    </p>
    
    <p class="mb-3">
      Nur kelkaj saĝuloj restis. Kaj nun ili senhelpe rigardis al la tiel soifita Libera Tero. Sen homoj, sen vivestaĵoj jam, morta kaj fremda Tero kuŝis antaŭ ili.
    </p>

    <p class="mb-3">
      Ili donis al la homaro Liberon, Sendependon kaj Homajn Rajtojn!
    </p>
    
    <p class="mb-3">
      Post kelka tempo tute neniiĝis ruinoj de la Domoj, kaj en la kosmo restis nur – glata pura Tero, rotacianta ĉirkaŭ la Suno.
    </p>
    `
  )
}

const itemName = {
  esp: 'La epizodo el la vivo de la Tero'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;